module.exports = __webpack_public_path__ + "static/media/o7.c7d200fe.png";